import { useTranslation } from "@outschool/localization";
import { CategoryPartial } from "@outschool/ui-components-website";

export const useTutoringNavMenus = (): CategoryPartial[] => {
  const { t } = useTranslation(
    "client\\components\\tutoring\\hooks\\useTutoringNavMenus"
  );

  return [
    {
      nameTitleCased: t("English tutors"),
      slug: "english-tutoring",
      showMore: true,
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("English Language Arts"),
          slug: "english-tutoring",
          subcategories: [
            {
              nameTitleCased: t("Pre-K & Kindergarten"),
              slug: "pre-k-and-kindergarten-english-tutoring"
            },
            {
              nameTitleCased: t("Elementary School"),
              slug: "elementary-school-english-tutoring"
            },
            {
              nameTitleCased: t("Middle School"),
              slug: "middle-school-english-tutoring"
            },
            {
              nameTitleCased: t("High School"),
              slug: "high-school-english-tutoring"
            }
          ]
        },
        {
          nameTitleCased: t("Reading"),
          slug: "reading-tutoring",
          subcategories: [
            {
              nameTitleCased: t("Reading Comprehension"),
              slug: "reading-comprehension-tutoring"
            },
            { nameTitleCased: t("Phonics"), slug: "phonics-tutoring" }
          ]
        },
        {
          nameTitleCased: t("Writing"),
          slug: "writing-tutoring",
          subcategories: [
            {
              nameTitleCased: t("Essay Writing"),
              slug: "essay-writing-tutoring"
            },
            {
              nameTitleCased: t("Creative Writing"),
              slug: "creative-writing-tutoring"
            },
            { nameTitleCased: t("Spelling"), slug: "spelling-tutoring" },
            { nameTitleCased: t("Grammar"), slug: "grammar-tutoring" }
          ]
        },
        {
          nameTitleCased: t("Public Speaking"),
          slug: "public-speaking-tutoring"
        }
      ]
    },
    {
      nameTitleCased: t("Math tutors"),
      slug: "math-tutoring",
      showMore: true,
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("Math"),
          slug: "math-tutoring",
          subcategories: [
            {
              nameTitleCased: t("Pre-K & Kindergarten"),
              slug: "pre-k-and-kindergarten-math-tutoring"
            },
            {
              nameTitleCased: t("Elementary School"),
              slug: "elementary-school-math-tutoring"
            },
            {
              nameTitleCased: t("Middle School"),
              slug: "middle-school-math-tutoring"
            },
            {
              nameTitleCased: t("High School"),
              slug: "high-school-math-tutoring"
            }
          ]
        },
        {
          nameTitleCased: t("Counting & Numbers"),
          slug: "counting-and-numbers-tutoring"
        },
        {
          nameTitleCased: t("Arithmetic"),
          slug: "arithmetic-tutoring"
        },
        {
          nameTitleCased: t("Multiplication"),
          slug: "multiplication-tutoring"
        },
        { nameTitleCased: t("Fractions"), slug: "fractions-tutoring" },
        { nameTitleCased: t("Pre-Algebra"), slug: "pre-algebra-tutoring" },
        { nameTitleCased: t("Algebra 1"), slug: "algebra-1-tutoring" },
        { nameTitleCased: t("Algebra 2"), slug: "algebra-2-tutoring" },
        { nameTitleCased: t("Geometry"), slug: "geometry-tutoring" }
      ]
    },
    {
      nameTitleCased: t("Arts & Music tutors"),
      slug: "arts-and-crafts-tutoring",
      showMore: true,
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("Arts"),
          slug: "arts-tutoring",
          subcategories: [
            { nameTitleCased: t("Drawing"), slug: "drawing-tutoring" },
            { nameTitleCased: t("Acting"), slug: "private-acting-lessons" },
            { nameTitleCased: t("Digital Art"), slug: "digital-art-tutoring" },
            { nameTitleCased: t("Animation"), slug: "animation-tutoring" },
            {
              nameTitleCased: t("Musical Theater"),
              slug: "musical-theater-tutoring"
            },
            { nameTitleCased: t("Dance"), slug: "dance-private-lessons" },
            { nameTitleCased: t("Crafts"), slug: "crafts-tutoring" },
            { nameTitleCased: t("Ballet"), slug: "ballet-private-lessons" }
          ]
        },
        {
          nameTitleCased: t("Music"),
          slug: "private-music-lessons",
          subcategories: [
            { nameTitleCased: t("Piano"), slug: "private-piano-lessons" },
            { nameTitleCased: t("Guitar"), slug: "private-guitar-lessons" },
            { nameTitleCased: t("Singing"), slug: "private-singing-lessons" },
            {
              nameTitleCased: t("Violin & Viola"),
              slug: "private-violin-lessons"
            },
            {
              nameTitleCased: t("Drums & Percssion"),
              slug: "private-drums-lessons"
            },
            { nameTitleCased: t("Ukulele"), slug: "private-ukulele-lessons" },
            { nameTitleCased: t("Flute"), slug: "private-flute-lessons" },
            { nameTitleCased: t("Trumpet"), slug: "private-trumpet-lessons" },
            { nameTitleCased: t("Cello"), slug: "private-cello-lessons" },
            {
              nameTitleCased: t("Bass Guitar"),
              slug: "private-bass-guitar-lessons"
            },
            {
              nameTitleCased: t("Music Theory"),
              slug: "music-theory-tutoring"
            },
            { nameTitleCased: t("Clarinet"), slug: "private-clarinet-lessons" },
            {
              nameTitleCased: t("Saxophone"),
              slug: "private-saxophone-lessons"
            }
          ]
        }
      ]
    },
    {
      nameTitleCased: t("Languages tutors"),
      slug: "languages-tutoring",
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("Languages"),
          slug: "languages-tutoring",
          can_link: true,
          subcategories: [
            { nameTitleCased: t("Spanish"), slug: "spanish-tutoring" },
            { nameTitleCased: t("English"), slug: "english-esl-tutoring" },
            { nameTitleCased: t("French"), slug: "french-tutoring" },
            {
              nameTitleCased: t("Mandarin"),
              slug: "private-mandarin-tutoring"
            },
            {
              nameTitleCased: t("Sign Language"),
              slug: "sign-language-tutoring"
            },
            { nameTitleCased: t("Japanese"), slug: "japanese-tutoring" },
            { nameTitleCased: t("Russian"), slug: "russian-tutoring" },
            { nameTitleCased: t("Latin"), slug: "latin-tutoring" },
            { nameTitleCased: t("Italian"), slug: "italian-tutoring" },
            { nameTitleCased: t("Chinese"), slug: "chinese-tutoring" },
            { nameTitleCased: t("German"), slug: "german-tutoring" }
          ]
        }
      ]
    },
    {
      nameTitleCased: t("Science tutors"),
      slug: "science-tutoring",
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("Science"),
          slug: "science-tutoring",
          subcategories: [
            {
              nameTitleCased: t("Pre-K & Kindergarten"),
              slug: "pre-k-and-kindergarten-science-tutoring"
            },
            {
              nameTitleCased: t("Elementary School"),
              slug: "elementary-school-science-tutoring"
            },
            {
              nameTitleCased: t("Middle School"),
              slug: "middle-school-science-tutoring"
            },
            {
              nameTitleCased: t("High School"),
              slug: "high-school-science-tutoring"
            }
          ]
        },
        { nameTitleCased: t("Chemistry"), slug: "chemistry-tutoring" },
        { nameTitleCased: t("Biology"), slug: "biology-tutoring" },
        { nameTitleCased: t("Physics"), slug: "physics-tutoring" },
        {
          nameTitleCased: t("Animals & Zoology"),
          slug: "animals-and-zoology-tutoring"
        }
      ]
    },
    {
      nameTitleCased: t("More"),
      slug: "tutoring-by-subject",
      can_link: true,
      subcategories: [
        {
          nameTitleCased: t("More Tutoring Subjects"),
          slug: "tutoring-by-subject",
          subcategories: [
            {
              nameTitleCased: t("Life Skills"),
              slug: "life-skills-tutoring"
            },
            {
              nameTitleCased: t("Coding & Tech"),
              slug: "coding-and-tech-tutoring"
            },
            {
              nameTitleCased: t("Health & Wellness"),
              slug: "health-and-wellness-tutoring"
            },
            {
              nameTitleCased: t("Games & Hobbies"),
              slug: "games-and-hobbies-tutoring"
            },
            {
              nameTitleCased: t("Social Studies"),
              slug: "social-studies-tutoring"
            },
            {
              nameTitleCased: t("Test Prep"),
              slug: "test-prep-tutoring"
            }
          ]
        },
        {
          nameTitleCased: "Special Needs",
          slug: "special-needs-tutoring",
          subcategories: [
            { nameTitleCased: t("ADHD"), slug: "adhd-tutoring" },
            { nameTitleCased: t("Autism"), slug: "autism-tutor" },
            { nameTitleCased: t("Dyslexia"), slug: "dyslexia-tutoring" },
            { nameTitleCased: t("Dyscalculia"), slug: "dyscalculia-tutoring" },
            {
              nameTitleCased: t("Executive Function"),
              slug: "executive-function-tutoring"
            }
          ]
        },
        {
          nameTitleCased: "Group classes",
          slug: "group-classes",
          subcategories: [
            {
              nameTitleCased: "Courses",
              slug: "courses"
            }
          ]
        }
      ]
    }
  ];
};
